export interface ApiPutHistoryRequest {
    current_step: string;
    task_id: string;
}

export const PutHistory = Symbol('PutHistory');

export interface PutHistory {
    putHistory(data: ApiPutHistoryRequest): Promise<void>;
}
